const GradualOutputLevelCorrespondence = {
	BELOW: 'Alatta van',
	FIT: 'Igen',
	OVER: 'Inkább posztgraduális',
};

export default GradualOutputLevelCorrespondence;
